import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-bases',
  templateUrl: './bases.component.html',
  styleUrls: ['./bases.component.scss']
})
export class BasesComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;
  modal = {
    active: false,
    data: {}
  };
  userBase;
  selectedBase;
  pilots = [];
  homeBases = [];
  bases = [];
  userIsSysAdmin = false;
  headings = [
    {
      label: 'Base Name',
      key: 'name'
    },
    {
      label: 'Code',
      key: 'code'
    },
    {
      label: 'Active',
      key: 'active'
    }
  ];
  settings = {
    label: 'New Base',
    action: 'create',
    route: 'bases',
    target: 'bases'
  };

  constructor(private toast: ToastService) {}

  async ngOnInit() {
    if (this.userInfo.role == 'sysadmin') {
      this.userIsSysAdmin = true;
    }

    axios
    .get(environment.API_URL + '/base/dropdown/main', {
      headers: { Authorization: 'Bearer ' + this.token }
    })
    .then((response) => {
      this.homeBases = response.data;

      this.homeBases.forEach((homeBase) => {
        homeBase.name = homeBase.text + ' | ' + homeBase.baseCode;
        homeBase.value = homeBase.baseId;

        if (homeBase.baseCode === this.userInfo.baseCode) {
          this.selectedBase = homeBase;
        }
      });

      this.getBases();

    })
    .catch((error) => {
      console.dir(error);
    });

    this.getBases();
  }

  selectHomeBase(selectedBase) {
    this.selectedBase = selectedBase;
    this.getBases();
  }

  getBases = async () => {
    this.loading = true;
    this.userBase = this.userInfo.baseCode;
    let baseCode = this.selectedBase.baseCode;

    let bases = await axios.get(
      environment.API_URL + '/base/?type=spike&baseCode=' + baseCode,
      {
        headers: { Authorization: 'Bearer ' + this.token }
      }
    );
    this.bases = bases.data.value;
    this.bases.forEach((base) => {
      if (base.deleted) {
        base.active = 'No';
      } else {
        base.active = 'Yes';
      }
    });

    this.loading = false;
  };

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.delete(data.base);
    }
    this.modal.active = false;
  };
  modalDenied = (data) => {
    this.modal.active = false;
  };

  confirmDeleteBase = (base) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this base?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        base: base
      },
      active: true
    };
  };

  delete = async (row) => {
    let id = '';
    if (row.id) {
      id = row.id;
    } else if (row.href) {
      id = row.href.slice(row.href.lastIndexOf('/') + 1, row.href.length);
    }
    let deleted = await axios
      .delete(environment.API_URL + '/base/' + id + '/delete', {
        headers: { Authorization: 'Bearer ' + this.token }
      })
      .then((response) => {
        this.toast.show('Success deleting base', 'success');
        this.getBases();
      })
      .catch((error) => {
        this.toast.show('Error deleting base', 'error');
      });
  };
}
